<template>
    <div class="forget-password">
        <div class="modal fade register-page1" id="staticBackdrop-two" data-bs-backdrop="static" data-bs-keyboard="false"
            tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="container-fluid login-module-wrapper">
                            <div class="row">
                                <button ref="close_btn" type="button" @click="refreshData()" class="btn-close close-top" 
                                    data-bs-dismiss="modal" aria-label="Close">
                                </button>
                                <div class="col-12 col-md-5">
                                    <div class="text-center">
                                        <img  rel="preload"  class="img-fluid logoregisterPage" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="logo">
                                        <!-- <img  rel="preload"   src="@/assets/images/betfairlogo.webp" class="img-fluid m-top"> -->
                                        <img  rel="preload"   src="@/assets/images/loginImg2.webp" class="img-fluid filterlogin m-top">
                                    </div>
                                </div>
                                <div class="col-12 col-md-7">
                                    <!-- <h2 class="regi-acc">Trouble Logging In?</h2> -->
                                    <!-- <h2 class="regi-acc">{{ $t('forgot-password-cap','FORGOT PASSWORD')}}</h2> -->
                                    <!-- <p class="create">
                                        Enter your Phone and we'll send <br>
                                        you a otp to get back into your account.
                                    </p> -->
                                    <form class="reg-form">
                                        <div class="form-group">
                                            <!-- <label>Mobile number*</label> -->
                                            <div class="get-mob" :disabled="otpSent" :class="{ 'get-mob': !otpSent, 'get-mob-dis': otpSent }">
                                                <div class="col-auto">
                                                    <select class="form-select w_length_s" v-model="form.code" :disabled="otpSent">
                                                        <option :value="allowedCountry.phonecode" v-for="(allowedCountry, countryIndex) in $siteSettings.data?.country_code_list"  :key="countryIndex">+{{ allowedCountry.phonecode }}</option>
                                                    </select>
                                                </div>
                                                <div class="inp-img">
                                                    <img  rel="preload"   src="@/assets/images/mob_icon.svg" alt="">
                                                </div>
                                                <input v-model="form.mobileNo" minlength="10" maxlength="10" :disabled="otpSent" :class="{ enabled: !otpSent, disabled: otpSent }" 
                                                    class="form-control add" id="autoSizingInput1" :placeholder="$t('enter-phone-number','Enter Phone Number') "
                                                    @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999);">
                                                    <div class="get-code">
                                                        <button class="loader-btn" @click="sendOtpCall();phnInit=true;otpBtnInit=true;" :class="{ 'btn-loading': false, 'disabled-login': timerRunning }" type="button">
                                                            {{ resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}
                                                            <span><b></b><b></b><b></b></span>
                                                        </button>
                                                    </div>
                                            </div>
                                            <div>
                                                <p v-if="phnInit && checkValidation?.mobile?.length > 0" v-for="(err, index) in checkValidation?.mobile" :key="index" class="wrong-message mt-1">
                                                    {{ $t(err.lang, err.error) }}
                                                </p>
                                                <p v-if="otpBtnInit && form.mobileNo?.length == 10 && !isOtpApiCalled" class="wrong-message mt-1">
                                                    {{$t('please-click-on-send-otp','Please Click On Get OTP')}}
                                                </p>
                                            </div>
                                            
                                        </div>

                                        
                                        <div class="get-input-field for">
                                            <!-- <label>OTP*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.otp" required="1" maxlength="6"  type="tel" class="form-control"
                                                :placeholder="$t('enter-otp','Enter OTP') " @input="form.otp = $helper.sanitizeNumber(form.otp, 999999);">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/key.svg" alt=""></div>
                                                <span v-if="timerRunning" class="otp-timer">{{ $t('resend-otp-in', 'Resend OTP In') }} {{ formatTime(minutes) + ':' + formatTime(seconds) }}</span>
                                                
                                                <div>
                                                    <p v-if="init && checkValidation?.otp?.length > 0" v-for="(err, index) in checkValidation?.otp" :key="index" class="wrong-message mt-1">
                                                    {{ $t(err.lang, err.error) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div class="get-input-field for">
                                            <!-- <label>Password*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.password"  required="1" maxlength="20" minLength="8"  :type="passwordFieldType" class="form-control"  :placeholder="$t('enter-pass','Enter Password') " 
                                                    @input="form.password = $helper.sanitizeDetails('password', form.password, 20);">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/lock_icon.svg" alt=""></div>
                                                <div class="eye-icn-sec" @click="togglePasswordVisibility('password')">
                                                    <img  rel="preload"  v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                                    <img  rel="preload"  v-else src="@/assets/images/eye-open.webp" alt="">
                                                </div>
                                                <div>
                                                    <p v-if="init && checkValidation?.password?.length > 0" v-for="(err, index) in checkValidation?.password" :key="index" class="wrong-message mt-1">
                                                    {{ $t(err.lang, err.error) }}</p>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        

                                        <div class="get-input-field for">
                                            <!-- <label>Confirm Password*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.confirmPassword" required="1" maxlength="20" minlength="8" :type="confPasswordFieldType" class="form-control"
                                                :placeholder="$t('enter-conf-password','Enter Confirm Password')" 
                                                @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20);">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/lock_icon.svg" alt=""></div>
                                                <div class="eye-icn-sec" @click="togglePasswordVisibility">
                                                    <img  rel="preload"  v-if="confPasswordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                                    <img  rel="preload"  v-else src="@/assets/images/eye-open.webp">
                                                </div>
                                                <div>
                                                    <p v-if="init && checkValidation?.confirmPassword?.length > 0" v-for="(err, index) in checkValidation?.confirmPassword" :key="index" class="wrong-message mt-1">
                                                        {{ $t(err.lang, err.error) }}   
                                                    </p>
                                                </div>
                                            </div>
                                            
                                        </div>

                                        <button type="button" @click="forgetPasswordCall()"   class="btn btn-register loader-btn mt-0">
                                            {{$t('update-password','Update Password')}}
                                            <span><b></b><b></b><b></b></span>
                                        </button>

                                        <div class="for-pass">
                                            <p class="login-with-acc">{{$t('remember-your-password','Remember Your Password')}}?&nbsp;
                                                <a data-bs-toggle="modal" href="#staticBackdrop-one" @click="refreshData()">
                                                    {{$t('login','Login')}}
                                                </a>
                                            </p>
                                            <p class="text-center">
                                                <a href="#register-btn" data-bs-toggle="modal"  @click="refreshData()"> {{ $t('create-new-account','Create New Account')}}</a>
                                            </p>
                                        </div>
                                        <!-- <h3 class="whats-with">{{ $t('or-continue-with', 'Or Continue With') }} 
                                            <span class="whats-with-now">{{ $t('whatsapp', 'Whatsapp') }}</span>
                                        </h3>
                                        <div v-if="$siteSettings?.data?.social_link?.whatsappno1" class="button-whatsapp">
                                            <a :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" class="btn-whatsapp" target="_blank">
                                                <img  rel="preload"   src="@/assets/images/whatsapp.webp" alt="">{{ $t('whatsapp-now', 'Whatsapp Now') }} 
                                            </a>
                                        </div>
                                        <p class="whats-with-acc">{{ $t('dont-have-an-account', "Don't Have An Account") }}? &nbsp;
                                            <a data-bs-toggle="modal" href="#register-btn" @click="refreshData()">{{$t('register','Register')}}</a>
                                        </p> -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';
export default {
    name: 'ForgotPassword',
    extends: commonAuth,
    data() {
        return {
            form: {
                code: "91",
                mobileNo: "",
                otp: [],
                password: "",
                confirmPassword: "",
                captchaText: "",
            },
            phnInit:false,
            loadingUpdate:false,
            otpBtnInit:false
        };
    },
    computed: {
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'forgot-password',
                this.form.mobileNo, 
                this.form.otp, 
                this.form.password,
                this.form.confirmPassword,
            );
            if(this.init || this.phnInit){
                return validationErrors;
            }
        }
    },
    mounted(){
        if(this.$route.name == 'forget-password' && !this.$auth.status){
            this.$helper.openModal('#staticBackdrop-two');
        }
        else if(this.$route.name == 'forget-password' && this.$auth.status){
            this.$router.push('/')
        }
    },
    methods: {
        forgetPasswordCall() {
            this.phnInit = true;
            this.otpBtnInit = true;

            if (!this.otpSent){ 
                return
            } else {
                this.init = true;
                if(Object.keys(this.checkValidation).length === 0) {
                    this.forgotServiceCall();
                }
            }
        },
        async forgotServiceCall() {
            this.loadingUpdate= true;
            let data = {
                "phone": this.form.mobileNo,
                "cncode": this.form.code,
                "password": this.form.password,
                "confirm_password": this.form.confirmPassword,
                "otp": this.getOtp(),

            };
            this.$apiCall('post','FORGOT_PASSWORD', data).then(response => {
                if (response) {
                    this.loadingUpdate = false;
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$helper.closeModal('staticBackdrop-two');
                            this.$helper.showLogin()
                        }
                    }
                }
            }).catch(error => {
                this.loadingUpdate = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
    }
}
</script>
<style scoped>
.disabled-login{
    pointer-events: none;
}
</style>